import {
  KHACHHANG_THEMMOI,
  KHACHHANG_THEMMOI_SUCCESS,
  KHACHHANG_THEMMOI_FAILURE,
} from "./actionTypes";

export const themMoiKhachHang = (dataPost) => ({
  type: KHACHHANG_THEMMOI,
  dataPost,
});

export const themMoiKhachHangSuccess = () => ({
  type: KHACHHANG_THEMMOI_SUCCESS,
});

export const themMoiKhachHangFailure = () => ({
  type: KHACHHANG_THEMMOI_FAILURE,
});
